import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'secondsToHoursMinutes',
    standalone: false,
})
export class SecondsToHoursMinutesPipe implements PipeTransform {
    transform(value: number | string): string {
        const seconds = Number(value);
        if (seconds == null || isNaN(seconds)) return '00h 00m';
        const minutes = Math.ceil(seconds / 60);
        const hoursStr = Math.floor(minutes / 60)
            .toString()
            .padStart(2, '0');
        const minutesStr = Math.round(minutes % 60)
            .toString()
            .padStart(2, '0');
        return `${hoursStr}h ${minutesStr}m`;
    }
}
